export const en = {
  login: 'LOGIN',
  wrong: 'Wrong Email or Password',
  email: 'Email*',
  field: 'This field is mandatory',
  password: 'Password*',
  remember_me: 'Remember me',
  forgot_password: 'Forgot password?',
  Login: 'Login',
  lang: 'العربيه',
  Request_Sent_Successfully: 'Request Sent Successfully',
  Please_Enter:
    'Please Enter Your Email And The Admin Will Change The Password For You',
  Forgot_password: 'Forgot password',
  Wrong_Email: 'Wrong Email',
  Send: 'Send',
  Enter_a_verification_code: 'Enter a verification code.',
  verification:
    'A verification code was just sent to the email you have entered',
  Invalid_code: 'Invalid code. try again.',
  Verify: 'Verify',
  This_account_is_blocked_Please_visit_your_admin:
    'This account is blocked Please visit your admin.',
  Thanks: 'Thanks',
  trust_this_computer: 'Trust this computer',
};
export const ar = {
  Thanks: 'شكرا',
  This_account_is_blocked_Please_visit_your_admin:
    'تم حظر هذا الحساب يرجى زيارة المسؤول الخاص بك.',
  Verify: 'تحقق',
  Invalid_code: 'الرمز غير صحيح. حاول مجدداً.',
  verification: 'تم إرسال رمز التحقق للتو إلى البريد الإلكتروني الذي أدخلته',
  Enter_a_verification_code: 'أدخل رمز التحقق.',
  Send: 'ارسال',
  Wrong_Email: 'بريد إلكتروني خاطئ',
  Forgot_password: 'هل نسيت كلمة السر',
  Please_Enter:
    'الرجاء إدخال بريدك الإلكتروني وسيقوم المسؤول بتغيير كلمة المرور لك',
  Request_Sent_Successfully: 'تم إرسال الطلب بنجاح',
  login: 'تسجيل الدخول',
  wrong: ' خطأ في البريد الاكتروني او كلمة المرور ',
  email: 'البريد الإلكتروني*',
  field: 'هذا الحقل إلزامي',
  password: 'كلمة المرور*',
  remember_me: 'تذكرني',
  forgot_password: 'هل نسيت كلمة السر؟',
  Login: 'سجل الدخول',
  lang: 'English',
  trust_this_computer: 'ثق بهذا الكمبيوتر',
};
